module.exports = __webpack_public_path__ + "static/media/manageprops.369e610a.png";